import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Fathom',
    description: 'An endless three dimensional flythrough of suspended photo cards that drift toward the viewer as you scroll.',
    url: getOrigin()
}

export const navLinks: NavLink[] = [
    { href: '/', label: 'Index' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]
